import React, { useState, useEffect } from 'react';
import { ManText } from "@craft-design-system/core-components-react";
import { useFilterContext } from './FilterContext';
import { useDeselectContext } from './DeselectContext';

// Helper function to format ISO date strings to 'YYYY-MM-DD'
const formatDate = (val) => {
  if (typeof val === 'string' && /^\d{4}-\d{2}-\d{2}T/.test(val)) {
    const date = new Date(val);
    return date.toISOString().split('T')[0];
  }
  return val;
};

const Selected_filters = () => {
  const { filterdata, updateFilterData } = useFilterContext();
  const { updatedeselectdata } = useDeselectContext();
  const [storedFilterData, setStoredFilterData] = useState(null);

  const unselectOption = (dropdown) => {
    const updatedFilterData = { ...filterdata };
    delete updatedFilterData[dropdown];
    updateFilterData(updatedFilterData);
    updatedeselectdata(null);
    setTimeout(() => {
      updatedeselectdata(dropdown);
    }, 0);
  };

  useEffect(() => {
    if (filterdata && filterdata.hasOwnProperty('button_clicked') && filterdata['button_clicked'] === true) {
      setStoredFilterData(filterdata);
    }
  }, [filterdata]);

  return (
    <div style={{ background: 'white', padding: '10px', borderRadius: '8px' }}>
      <ManText className="filter-title" variant={"heading-l"} as={"span"} style={{ marginLeft: '11px' }}>
        Filter criteria
      </ManText>
      <div style={{ marginLeft: '11px', marginTop: '5px', display: 'flex', alignItems: 'center', gap: '8px' }}>
        <ManText variant={"text-s"} as={"span"} style={{ color: '#5B6F85', fontStyle: 'italic' }}>
          Aggregations of multiple vehicles and/or multiple days do not consider data points that are not meeting BEV Analyzer's quality criteria.
        </ManText>
        <a 
          href="https://confluence.collaboration-man.com/pages/viewpage.action?pageId=377090844&spaceKey=MTBDANDA&title=09-07%2BRelease%2B1.4.1%2B26%2B01%2B2026%2BQuality%2Bcriteria" 
          target="_blank" 
          rel="noopener noreferrer"
          title="Learn more about quality criteria"
          style={{
            color: '#0066CC',
            textDecoration: 'none',
            fontSize: '14px',
            cursor: 'pointer',
            display: 'flex',
            alignItems: 'center',
            padding: '2px'
          }}
          onMouseOver={(e) => e.target.style.color = '#004499'}
          onMouseOut={(e) => e.target.style.color = '#0066CC'}
        >
          ↗
        </a>
      </div>

      {storedFilterData ? (
        <div style={{ display: 'flex', flexWrap: 'wrap', paddingTop: '10px' }}>
          {Object.entries(storedFilterData).map(([key, value]) => (
            value && value.length > 0 && (
              <div key={key} style={{ margin: '10px', padding: '10px', background: '#F8F8F8', borderRadius: '5px', display: 'flex', alignItems: 'center' }}>
                <button
                  // onClick={() => unselectOption(key)}
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                    border: 'none',
                    background: 'transparent',
                    cursor: 'pointer'
                  }}
                >
                  <ManText className="filter-title" variant={"heading-s"} as={"span"} style={{ marginRight: '5px' }}>
                    {key}: {Array.isArray(value) ? value.map(v => formatDate(v)).join(', ') : formatDate(value)}
                  </ManText>
                  <span style={{
                    fontWeight: 'bold',
                    marginLeft: '5px',
                    fontSize: '20px',
                    color: '#FF0000',
                    cursor: 'pointer'
                  }}>
                  </span>
                </button>
              </div>
            )
          ))}
        </div>
      ) : (
        <ManText variant={"heading-s"} as={"span"} style={{ marginLeft: '11px', color: '#5B6F85' }}>
          No filters applied.
        </ManText>
      )}
    </div>
  );
};

export default Selected_filters;
